// This is a public availability feed, not account-specific AWS Health data.
export const bedrockServiceStatus = (xml, now = Date.now()) => {
  if (typeof xml !== 'string' || xml.length > 128 * 1024) return null
  const document = new DOMParser().parseFromString(xml, 'application/xml')
  if (document.querySelector('parsererror')) return null
  const channel = document.querySelector('rss > channel')
  if (!channel || channel.querySelector('title')?.textContent !== 'Amazon Bedrock (Ohio) Service Status') return null
  const updated = Date.parse(channel.querySelector('lastBuildDate')?.textContent || '')
  // Never interpret an old, truncated, or changed feed as proof of normal service.
  if (!Number.isFinite(updated) || now - updated > 15 * 60 * 1000 || updated - now > 2 * 60 * 1000) return null
  let status = { label: 'Online', indicator: 'none' }
  for (const item of channel.querySelectorAll('item')) {
    const title = item.querySelector('title')?.textContent || ''
    if (/^(?:Service is operating normally:|Resolved:|\[RESOLVED\])/i.test(title)) continue
    if (/^Service disruption:/i.test(title)) status = { label: 'Offline', indicator: 'major' }
    else if (/^Performance issues?:/i.test(title)) {
      if (status.label !== 'Offline') status = { label: 'Degraded', indicator: 'minor' }
    } else return null // AWS can change RSS wording; use connection fallback rather than guess.
  }
  return status
}
